import { useState } from 'react';

import { Text } from '@mantine/core';

import { Accordion } from '../../../../DataDisplay';
import classes from './AccordionCard.module.css';

const AccordionCard = ({
  isCardCollapsed,
  title,
  children,
  description,
}: {
  isCardCollapsed: boolean;
  title: string;
  children: React.ReactNode;
  description?: string;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(isCardCollapsed);

  return (
    <Accordion
      defaultValue={isCollapsed ? undefined : title}
      classNames={classes}
      onChange={(value) => setIsCollapsed(value === title)}
      transitionDuration={150}
    >
      <Accordion.Item value={title}>
        <Accordion.Control>
          {title}
          {description && (
            <Text fz="xs" c="gray" mt={4}>
              {description}
            </Text>
          )}
        </Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export { AccordionCard };
